import { AnyAction, Dispatch, Middleware, MiddlewareAPI } from "redux";
import ActionTypes from "../../../constants/ActionTypes";
import ApiUrls from "../../../constants/ApiUrls";
import MiddlewareEntities from "../../../constants/MiddlewareEntities";
import { PakCitiesFactory } from "../../../factories/pak/PakCitiesFactory";
import { PakNeighborhoodFactory } from "../../../factories/pak/PakNeighborhoodFactory";
import { PakStreetFactory } from "../../../factories/pak/PakStreetFactory";
import { apiRequest } from "../api/actions";
import { createErrorNotification } from "../notification/actions";
import { setCitiesAction, setNeighborhoodAction, setStreetsAction } from "./actions";


export const getCitiesMiddleware: Middleware = (store: MiddlewareAPI) => (next: Dispatch) => (action: AnyAction) => {
  next(action);

  switch (action.type) {
  case ActionTypes.PAK.FETCH_CITIES:
    next(apiRequest(
      null,
      'GET',
      `${ApiUrls.PAK.GET_CITIES}`,
      null,
      null,
      MiddlewareEntities.PAK.PAK_CITY,
      {})
    );
    break;
  case `${MiddlewareEntities.PAK.PAK_CITY} ${ActionTypes.API_SUCCESS}`:
    next(setCitiesAction(PakCitiesFactory.create(action.payload.data.municipalities)));
    break;
  case `${MiddlewareEntities.PAK.PAK_CITY} ${ActionTypes.API_ERROR}`:
    next(createErrorNotification(action.payload.data,  MiddlewareEntities.PAK.PAK_CITY));
    break;
  }
};

export const getNeighborhoodMiddleware: Middleware = (store: MiddlewareAPI) => (next: Dispatch) => (action: AnyAction) => {
  next(action);

  switch (action.type) {
  case ActionTypes.PAK.FETCH_NEIGHBORHOODS:
    next(apiRequest(
      null,
      'GET',
      `${ApiUrls.PAK.GET_NEIGHBORHOODS}/${action.payload.municipality}/city/${action.payload.city ? action.payload.city : "" }`,
      null,
      null,
      MiddlewareEntities.PAK.PAK_NEIGHBORHOOD,
      {})
    );
    break;
  case `${MiddlewareEntities.PAK.PAK_NEIGHBORHOOD} ${ActionTypes.API_SUCCESS}`:
    next(setNeighborhoodAction(PakNeighborhoodFactory.create(action.payload.data.neighborhoods)));
    break;
  case `${MiddlewareEntities.PAK.PAK_NEIGHBORHOOD} ${ActionTypes.API_ERROR}`:
    next(createErrorNotification(action.payload.data,  MiddlewareEntities.PAK.PAK_NEIGHBORHOOD));
    break;
  }
};

export const getStreets: Middleware = (store: MiddlewareAPI) => (next: Dispatch) => (action: AnyAction) => {
  next(action);

  switch (action.type) {
  case ActionTypes.PAK.FETCH_STREETS:
    next(apiRequest(
      null,
      'GET',
      `${ApiUrls.PAK.GET_NEIGHBORHOODS}/${action.payload.municipality}/neighborhood/${action.payload.neighborhood}`,
      null,
      null,
      MiddlewareEntities.PAK.PAK_STREET,
      {})
    );
    break;
  case `${MiddlewareEntities.PAK.PAK_STREET} ${ActionTypes.API_SUCCESS}`:
    next(setStreetsAction(PakStreetFactory.create(action.payload.data.streets)));
    break;
  case `${MiddlewareEntities.PAK.PAK_STREET} ${ActionTypes.API_ERROR}`:
    next(createErrorNotification(action.payload.data,  MiddlewareEntities.PAK.PAK_STREET));
    break;
  }
};

export const pakMiddleware = [getCitiesMiddleware, getNeighborhoodMiddleware, getStreets];
